/**
 * Example values of the personal link buttons (Meta needs an example per dynamic URL button). The test message of a
 * template ("Test senden") sends exactly these, so its buttons can never open a real page: the router shows the page
 * "Test-Link" instead of "Link ungültig" (testLinkTarget).
 */
export const EXAMPLE_ID = '64b7f0c2a1b2c3d4e5f60718';
export const EXAMPLE_ID2 = '64b7f0c2a1b2c3d4e5f60719';
export const EXAMPLE_CONFIRMATION_TOKEN = '3f9c2a8b17d4e6f0a1b2c3d4e5f60718293a4b5c';

/** Page behind the button, by path prefix (shown on the Test-Link page) */
const PAGES: Array<{ prefix: string; text: string }> = [
    {prefix: '/substitution-inquiries/', text: 'die Vertretungsanfrage (Annehmen oder absagen)'},
    {prefix: '/takeover-offers/', text: 'das Übernahmeangebot'},
    {prefix: '/feedback/', text: 'das Feedback-Formular'},
    {prefix: '/makeup-rounds/', text: 'die Terminauswahl der Nachholrunde'},
    {prefix: '/planning/handout-events/advertiser-feedback/', text: 'das Feedback zur Austeilaktion'},
    {prefix: '/handout-event-confirmation/', text: 'die Terminbestätigung der Austeilaktion'},
];

/** Path of a test-message button → what the button opens in a real message; undefined = no test link */
export function testLinkTarget(path: string): string | undefined {
    const value = path || '';
    if (!value.includes(EXAMPLE_ID) && !value.includes(EXAMPLE_CONFIRMATION_TOKEN)) {
        return undefined;
    }
    return PAGES.find((page) => value.startsWith(page.prefix))?.text || 'die persönliche Seite';
}
